import { CLASSIFICATION_TYPE, PAGE_TYPE } from "../../constants";
import { eventTrackPayloadCreator } from "../../helpers/eventPayloadCreator";
import { EventData, EventPayload } from "../../types";

export interface MarketingBannerSecondaryCtaClickedPayload
  extends EventPayload {
  content?: {
    title: string;
  };
}

const DefaultEventData: Omit<EventData, "pageType"> = {
  pageDetail: "",
  eventName: "hero-secondary-cta-clicked",
  classification: CLASSIFICATION_TYPE.experienceEvent,
};

export const createMarketingBannerSecondaryCtaClickedTrackEventPayload = (
  pageType: PAGE_TYPE,
) => {
  return eventTrackPayloadCreator<MarketingBannerSecondaryCtaClickedPayload>({
    pageType,
    ...DefaultEventData,
  });
};
